//breakpoints

export default {
  values: {
    xs: 0,
    sm: 400,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  },
};
